/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SitesImport } from './routes/sites'
import { Route as SettingsImport } from './routes/settings'
import { Route as LayoutImport } from './routes/_layout'
import { Route as IndexImport } from './routes/index'
import { Route as SettingsOrgImport } from './routes/settings/org'
import { Route as AuthSelectOrganisationImport } from './routes/auth/select-organisation'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthErrorImport } from './routes/auth/error'
import { Route as LayoutTaxonomyIndexImport } from './routes/_layout/taxonomy/index'
import { Route as LayoutTaxaIndexImport } from './routes/_layout/taxa/index'
import { Route as SettingsOrgTagsImport } from './routes/settings/org/tags'
import { Route as LayoutTaxonomyTrashImport } from './routes/_layout/taxonomy/trash'
import { Route as LayoutTaxonomyNewImport } from './routes/_layout/taxonomy/new'
import { Route as LayoutTaxonomyTaxonIdImport } from './routes/_layout/taxonomy/$taxonId'
import { Route as LayoutTaxaTrashImport } from './routes/_layout/taxa/trash'
import { Route as LayoutSitesSiteSlugImport } from './routes/_layout/sites/$siteSlug'
import { Route as LayoutSiteSiteSlugImport } from './routes/_layout/site/$siteSlug'
import { Route as LayoutMaterialIdImport } from './routes/_layout/material/$id'
import { Route as LayoutAccessionIdImport } from './routes/_layout/accession/$id'
import { Route as SettingsSitesSiteSlugTagsImport } from './routes/settings/sites/$siteSlug/tags'
import { Route as LayoutSitesSiteSlugTrashImport } from './routes/_layout/sites/$siteSlug/trash'
import { Route as LayoutSitesSiteSlugMapImport } from './routes/_layout/sites/$siteSlug/map'
import { Route as LayoutSitesSiteSlugDashboardImport } from './routes/_layout/sites/$siteSlug/dashboard'
import { Route as LayoutSitesSiteSlugCollectionImport } from './routes/_layout/sites/$siteSlug/collection'
import { Route as LayoutSiteSiteSlugTrashImport } from './routes/_layout/site/$siteSlug/trash'
import { Route as LayoutSiteSiteSlugMapImport } from './routes/_layout/site/$siteSlug/map'
import { Route as LayoutSiteSiteSlugCollectionImport } from './routes/_layout/site/$siteSlug/collection'
import { Route as LayoutSitesSiteSlugMaterialsNewImport } from './routes/_layout/sites/$siteSlug/materials/new'
import { Route as LayoutSitesSiteSlugMaterialsMaterialNumberImport } from './routes/_layout/sites/$siteSlug/materials/$materialNumber'
import { Route as LayoutSitesSiteSlugMapMaterialsImport } from './routes/_layout/sites/$siteSlug/map/materials'
import { Route as LayoutSitesSiteSlugMapLocationsImport } from './routes/_layout/sites/$siteSlug/map/locations'
import { Route as LayoutSitesSiteSlugAccessionsCreateImport } from './routes/_layout/sites/$siteSlug/accessions/create'
import { Route as LayoutSitesSiteSlugAccessionsAccessionNumberImport } from './routes/_layout/sites/$siteSlug/accessions/$accessionNumber'
import { Route as LayoutSiteSiteSlugMaterialMaterialNumberImport } from './routes/_layout/site/$siteSlug/material/$materialNumber'
import { Route as LayoutSiteSiteSlugMapMaterialsImport } from './routes/_layout/site/$siteSlug/map/materials'
import { Route as LayoutSiteSiteSlugMapLocationsImport } from './routes/_layout/site/$siteSlug/map/locations'
import { Route as LayoutSiteSiteSlugAccessionAccessionNumberImport } from './routes/_layout/site/$siteSlug/accession/$accessionNumber'
import { Route as LayoutSitesSiteSlugMapMaterialMaterialNumberImport } from './routes/_layout/sites/$siteSlug/map/material/$materialNumber'
import { Route as LayoutSitesSiteSlugMapLocationLocationNameImport } from './routes/_layout/sites/$siteSlug/map/location/$locationName'
import { Route as LayoutSiteSiteSlugMapMaterialMaterialNumberImport } from './routes/_layout/site/$siteSlug/map/material/$materialNumber'
import { Route as LayoutSiteSiteSlugMapLocationLocationNameImport } from './routes/_layout/site/$siteSlug/map/location/$locationName'

// Create Virtual Routes

const LayoutSitesIndexLazyImport = createFileRoute('/_layout/sites/')()
const SettingsOrgMembersLazyImport = createFileRoute('/settings/org/members')()
const SettingsOrgGeneralLazyImport = createFileRoute('/settings/org/general')()
const SettingsOrgBillingLazyImport = createFileRoute('/settings/org/billing')()
const SettingsAccountProfileLazyImport = createFileRoute(
  '/settings/account/profile',
)()
const SettingsAccountPreferencesLazyImport = createFileRoute(
  '/settings/account/preferences',
)()
const LayoutTaxonTaxonIdLazyImport = createFileRoute(
  '/_layout/taxon/$taxonId',
)()
const LayoutTaxaNewLazyImport = createFileRoute('/_layout/taxa/new')()
const SettingsSitesSiteSlugPublicSiteLazyImport = createFileRoute(
  '/settings/sites/$siteSlug/public-site',
)()
const SettingsSitesSiteSlugMembersLazyImport = createFileRoute(
  '/settings/sites/$siteSlug/members',
)()
const SettingsSitesSiteSlugLocationsLazyImport = createFileRoute(
  '/settings/sites/$siteSlug/locations',
)()
const SettingsSitesSiteSlugGeneralLazyImport = createFileRoute(
  '/settings/sites/$siteSlug/general',
)()
const LayoutSiteSiteSlugDashboardLazyImport = createFileRoute(
  '/_layout/site/$siteSlug/dashboard',
)()
const LayoutSiteSiteSlugMaterialNewLazyImport = createFileRoute(
  '/_layout/site/$siteSlug/material/new',
)()
const LayoutSiteSiteSlugAccessionCreateLazyImport = createFileRoute(
  '/_layout/site/$siteSlug/accession/create',
)()

// Create/Update Routes

const SitesRoute = SitesImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsOrgRoute = SettingsOrgImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => SettingsRoute,
} as any)

const AuthSelectOrganisationRoute = AuthSelectOrganisationImport.update({
  id: '/auth/select-organisation',
  path: '/auth/select-organisation',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthErrorRoute = AuthErrorImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRoute,
} as any)

const LayoutSitesIndexLazyRoute = LayoutSitesIndexLazyImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/sites/index.lazy').then((d) => d.Route),
)

const LayoutTaxonomyIndexRoute = LayoutTaxonomyIndexImport.update({
  id: '/taxonomy/',
  path: '/taxonomy/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTaxaIndexRoute = LayoutTaxaIndexImport.update({
  id: '/taxa/',
  path: '/taxa/',
  getParentRoute: () => LayoutRoute,
} as any)

const SettingsOrgMembersLazyRoute = SettingsOrgMembersLazyImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => SettingsOrgRoute,
} as any).lazy(() =>
  import('./routes/settings/org/members.lazy').then((d) => d.Route),
)

const SettingsOrgGeneralLazyRoute = SettingsOrgGeneralLazyImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsOrgRoute,
} as any).lazy(() =>
  import('./routes/settings/org/general.lazy').then((d) => d.Route),
)

const SettingsOrgBillingLazyRoute = SettingsOrgBillingLazyImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsOrgRoute,
} as any).lazy(() =>
  import('./routes/settings/org/billing.lazy').then((d) => d.Route),
)

const SettingsAccountProfileLazyRoute = SettingsAccountProfileLazyImport.update(
  {
    id: '/account/profile',
    path: '/account/profile',
    getParentRoute: () => SettingsRoute,
  } as any,
).lazy(() =>
  import('./routes/settings/account/profile.lazy').then((d) => d.Route),
)

const SettingsAccountPreferencesLazyRoute =
  SettingsAccountPreferencesLazyImport.update({
    id: '/account/preferences',
    path: '/account/preferences',
    getParentRoute: () => SettingsRoute,
  } as any).lazy(() =>
    import('./routes/settings/account/preferences.lazy').then((d) => d.Route),
  )

const LayoutTaxonTaxonIdLazyRoute = LayoutTaxonTaxonIdLazyImport.update({
  id: '/taxon/$taxonId',
  path: '/taxon/$taxonId',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/taxon/$taxonId.lazy').then((d) => d.Route),
)

const LayoutTaxaNewLazyRoute = LayoutTaxaNewLazyImport.update({
  id: '/taxa/new',
  path: '/taxa/new',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/taxa/new.lazy').then((d) => d.Route),
)

const SettingsOrgTagsRoute = SettingsOrgTagsImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => SettingsOrgRoute,
} as any)

const LayoutTaxonomyTrashRoute = LayoutTaxonomyTrashImport.update({
  id: '/taxonomy/trash',
  path: '/taxonomy/trash',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTaxonomyNewRoute = LayoutTaxonomyNewImport.update({
  id: '/taxonomy/new',
  path: '/taxonomy/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTaxonomyTaxonIdRoute = LayoutTaxonomyTaxonIdImport.update({
  id: '/taxonomy/$taxonId',
  path: '/taxonomy/$taxonId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTaxaTrashRoute = LayoutTaxaTrashImport.update({
  id: '/taxa/trash',
  path: '/taxa/trash',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSitesSiteSlugRoute = LayoutSitesSiteSlugImport.update({
  id: '/sites/$siteSlug',
  path: '/sites/$siteSlug',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSiteSiteSlugRoute = LayoutSiteSiteSlugImport.update({
  id: '/site/$siteSlug',
  path: '/site/$siteSlug',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMaterialIdRoute = LayoutMaterialIdImport.update({
  id: '/material/$id',
  path: '/material/$id',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAccessionIdRoute = LayoutAccessionIdImport.update({
  id: '/accession/$id',
  path: '/accession/$id',
  getParentRoute: () => LayoutRoute,
} as any)

const SettingsSitesSiteSlugPublicSiteLazyRoute =
  SettingsSitesSiteSlugPublicSiteLazyImport.update({
    id: '/sites/$siteSlug/public-site',
    path: '/sites/$siteSlug/public-site',
    getParentRoute: () => SettingsRoute,
  } as any).lazy(() =>
    import('./routes/settings/sites/$siteSlug/public-site.lazy').then(
      (d) => d.Route,
    ),
  )

const SettingsSitesSiteSlugMembersLazyRoute =
  SettingsSitesSiteSlugMembersLazyImport.update({
    id: '/sites/$siteSlug/members',
    path: '/sites/$siteSlug/members',
    getParentRoute: () => SettingsRoute,
  } as any).lazy(() =>
    import('./routes/settings/sites/$siteSlug/members.lazy').then(
      (d) => d.Route,
    ),
  )

const SettingsSitesSiteSlugLocationsLazyRoute =
  SettingsSitesSiteSlugLocationsLazyImport.update({
    id: '/sites/$siteSlug/locations',
    path: '/sites/$siteSlug/locations',
    getParentRoute: () => SettingsRoute,
  } as any).lazy(() =>
    import('./routes/settings/sites/$siteSlug/locations.lazy').then(
      (d) => d.Route,
    ),
  )

const SettingsSitesSiteSlugGeneralLazyRoute =
  SettingsSitesSiteSlugGeneralLazyImport.update({
    id: '/sites/$siteSlug/general',
    path: '/sites/$siteSlug/general',
    getParentRoute: () => SettingsRoute,
  } as any).lazy(() =>
    import('./routes/settings/sites/$siteSlug/general.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutSiteSiteSlugDashboardLazyRoute =
  LayoutSiteSiteSlugDashboardLazyImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => LayoutSiteSiteSlugRoute,
  } as any).lazy(() =>
    import('./routes/_layout/site/$siteSlug/dashboard.lazy').then(
      (d) => d.Route,
    ),
  )

const SettingsSitesSiteSlugTagsRoute = SettingsSitesSiteSlugTagsImport.update({
  id: '/sites/$siteSlug/tags',
  path: '/sites/$siteSlug/tags',
  getParentRoute: () => SettingsRoute,
} as any)

const LayoutSitesSiteSlugTrashRoute = LayoutSitesSiteSlugTrashImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => LayoutSitesSiteSlugRoute,
} as any)

const LayoutSitesSiteSlugMapRoute = LayoutSitesSiteSlugMapImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => LayoutSitesSiteSlugRoute,
} as any)

const LayoutSitesSiteSlugDashboardRoute =
  LayoutSitesSiteSlugDashboardImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => LayoutSitesSiteSlugRoute,
  } as any)

const LayoutSitesSiteSlugCollectionRoute =
  LayoutSitesSiteSlugCollectionImport.update({
    id: '/collection',
    path: '/collection',
    getParentRoute: () => LayoutSitesSiteSlugRoute,
  } as any)

const LayoutSiteSiteSlugTrashRoute = LayoutSiteSiteSlugTrashImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => LayoutSiteSiteSlugRoute,
} as any)

const LayoutSiteSiteSlugMapRoute = LayoutSiteSiteSlugMapImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => LayoutSiteSiteSlugRoute,
} as any)

const LayoutSiteSiteSlugCollectionRoute =
  LayoutSiteSiteSlugCollectionImport.update({
    id: '/collection',
    path: '/collection',
    getParentRoute: () => LayoutSiteSiteSlugRoute,
  } as any)

const LayoutSiteSiteSlugMaterialNewLazyRoute =
  LayoutSiteSiteSlugMaterialNewLazyImport.update({
    id: '/material/new',
    path: '/material/new',
    getParentRoute: () => LayoutSiteSiteSlugRoute,
  } as any).lazy(() =>
    import('./routes/_layout/site/$siteSlug/material/new.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutSiteSiteSlugAccessionCreateLazyRoute =
  LayoutSiteSiteSlugAccessionCreateLazyImport.update({
    id: '/accession/create',
    path: '/accession/create',
    getParentRoute: () => LayoutSiteSiteSlugRoute,
  } as any).lazy(() =>
    import('./routes/_layout/site/$siteSlug/accession/create.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutSitesSiteSlugMaterialsNewRoute =
  LayoutSitesSiteSlugMaterialsNewImport.update({
    id: '/materials/new',
    path: '/materials/new',
    getParentRoute: () => LayoutSitesSiteSlugRoute,
  } as any)

const LayoutSitesSiteSlugMaterialsMaterialNumberRoute =
  LayoutSitesSiteSlugMaterialsMaterialNumberImport.update({
    id: '/materials/$materialNumber',
    path: '/materials/$materialNumber',
    getParentRoute: () => LayoutSitesSiteSlugRoute,
  } as any)

const LayoutSitesSiteSlugMapMaterialsRoute =
  LayoutSitesSiteSlugMapMaterialsImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => LayoutSitesSiteSlugMapRoute,
  } as any)

const LayoutSitesSiteSlugMapLocationsRoute =
  LayoutSitesSiteSlugMapLocationsImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => LayoutSitesSiteSlugMapRoute,
  } as any)

const LayoutSitesSiteSlugAccessionsCreateRoute =
  LayoutSitesSiteSlugAccessionsCreateImport.update({
    id: '/accessions/create',
    path: '/accessions/create',
    getParentRoute: () => LayoutSitesSiteSlugRoute,
  } as any)

const LayoutSitesSiteSlugAccessionsAccessionNumberRoute =
  LayoutSitesSiteSlugAccessionsAccessionNumberImport.update({
    id: '/accessions/$accessionNumber',
    path: '/accessions/$accessionNumber',
    getParentRoute: () => LayoutSitesSiteSlugRoute,
  } as any)

const LayoutSiteSiteSlugMaterialMaterialNumberRoute =
  LayoutSiteSiteSlugMaterialMaterialNumberImport.update({
    id: '/material/$materialNumber',
    path: '/material/$materialNumber',
    getParentRoute: () => LayoutSiteSiteSlugRoute,
  } as any)

const LayoutSiteSiteSlugMapMaterialsRoute =
  LayoutSiteSiteSlugMapMaterialsImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => LayoutSiteSiteSlugMapRoute,
  } as any)

const LayoutSiteSiteSlugMapLocationsRoute =
  LayoutSiteSiteSlugMapLocationsImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => LayoutSiteSiteSlugMapRoute,
  } as any)

const LayoutSiteSiteSlugAccessionAccessionNumberRoute =
  LayoutSiteSiteSlugAccessionAccessionNumberImport.update({
    id: '/accession/$accessionNumber',
    path: '/accession/$accessionNumber',
    getParentRoute: () => LayoutSiteSiteSlugRoute,
  } as any)

const LayoutSitesSiteSlugMapMaterialMaterialNumberRoute =
  LayoutSitesSiteSlugMapMaterialMaterialNumberImport.update({
    id: '/material/$materialNumber',
    path: '/material/$materialNumber',
    getParentRoute: () => LayoutSitesSiteSlugMapRoute,
  } as any)

const LayoutSitesSiteSlugMapLocationLocationNameRoute =
  LayoutSitesSiteSlugMapLocationLocationNameImport.update({
    id: '/location/$locationName',
    path: '/location/$locationName',
    getParentRoute: () => LayoutSitesSiteSlugMapRoute,
  } as any)

const LayoutSiteSiteSlugMapMaterialMaterialNumberRoute =
  LayoutSiteSiteSlugMapMaterialMaterialNumberImport.update({
    id: '/material/$materialNumber',
    path: '/material/$materialNumber',
    getParentRoute: () => LayoutSiteSiteSlugMapRoute,
  } as any)

const LayoutSiteSiteSlugMapLocationLocationNameRoute =
  LayoutSiteSiteSlugMapLocationLocationNameImport.update({
    id: '/location/$locationName',
    path: '/location/$locationName',
    getParentRoute: () => LayoutSiteSiteSlugMapRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/sites': {
      id: '/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof SitesImport
      parentRoute: typeof rootRoute
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/select-organisation': {
      id: '/auth/select-organisation'
      path: '/auth/select-organisation'
      fullPath: '/auth/select-organisation'
      preLoaderRoute: typeof AuthSelectOrganisationImport
      parentRoute: typeof rootRoute
    }
    '/settings/org': {
      id: '/settings/org'
      path: '/org'
      fullPath: '/settings/org'
      preLoaderRoute: typeof SettingsOrgImport
      parentRoute: typeof SettingsImport
    }
    '/_layout/accession/$id': {
      id: '/_layout/accession/$id'
      path: '/accession/$id'
      fullPath: '/accession/$id'
      preLoaderRoute: typeof LayoutAccessionIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/material/$id': {
      id: '/_layout/material/$id'
      path: '/material/$id'
      fullPath: '/material/$id'
      preLoaderRoute: typeof LayoutMaterialIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/site/$siteSlug': {
      id: '/_layout/site/$siteSlug'
      path: '/site/$siteSlug'
      fullPath: '/site/$siteSlug'
      preLoaderRoute: typeof LayoutSiteSiteSlugImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sites/$siteSlug': {
      id: '/_layout/sites/$siteSlug'
      path: '/sites/$siteSlug'
      fullPath: '/sites/$siteSlug'
      preLoaderRoute: typeof LayoutSitesSiteSlugImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/taxa/trash': {
      id: '/_layout/taxa/trash'
      path: '/taxa/trash'
      fullPath: '/taxa/trash'
      preLoaderRoute: typeof LayoutTaxaTrashImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/taxonomy/$taxonId': {
      id: '/_layout/taxonomy/$taxonId'
      path: '/taxonomy/$taxonId'
      fullPath: '/taxonomy/$taxonId'
      preLoaderRoute: typeof LayoutTaxonomyTaxonIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/taxonomy/new': {
      id: '/_layout/taxonomy/new'
      path: '/taxonomy/new'
      fullPath: '/taxonomy/new'
      preLoaderRoute: typeof LayoutTaxonomyNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/taxonomy/trash': {
      id: '/_layout/taxonomy/trash'
      path: '/taxonomy/trash'
      fullPath: '/taxonomy/trash'
      preLoaderRoute: typeof LayoutTaxonomyTrashImport
      parentRoute: typeof LayoutImport
    }
    '/settings/org/tags': {
      id: '/settings/org/tags'
      path: '/tags'
      fullPath: '/settings/org/tags'
      preLoaderRoute: typeof SettingsOrgTagsImport
      parentRoute: typeof SettingsOrgImport
    }
    '/_layout/taxa/new': {
      id: '/_layout/taxa/new'
      path: '/taxa/new'
      fullPath: '/taxa/new'
      preLoaderRoute: typeof LayoutTaxaNewLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/taxon/$taxonId': {
      id: '/_layout/taxon/$taxonId'
      path: '/taxon/$taxonId'
      fullPath: '/taxon/$taxonId'
      preLoaderRoute: typeof LayoutTaxonTaxonIdLazyImport
      parentRoute: typeof LayoutImport
    }
    '/settings/account/preferences': {
      id: '/settings/account/preferences'
      path: '/account/preferences'
      fullPath: '/settings/account/preferences'
      preLoaderRoute: typeof SettingsAccountPreferencesLazyImport
      parentRoute: typeof SettingsImport
    }
    '/settings/account/profile': {
      id: '/settings/account/profile'
      path: '/account/profile'
      fullPath: '/settings/account/profile'
      preLoaderRoute: typeof SettingsAccountProfileLazyImport
      parentRoute: typeof SettingsImport
    }
    '/settings/org/billing': {
      id: '/settings/org/billing'
      path: '/billing'
      fullPath: '/settings/org/billing'
      preLoaderRoute: typeof SettingsOrgBillingLazyImport
      parentRoute: typeof SettingsOrgImport
    }
    '/settings/org/general': {
      id: '/settings/org/general'
      path: '/general'
      fullPath: '/settings/org/general'
      preLoaderRoute: typeof SettingsOrgGeneralLazyImport
      parentRoute: typeof SettingsOrgImport
    }
    '/settings/org/members': {
      id: '/settings/org/members'
      path: '/members'
      fullPath: '/settings/org/members'
      preLoaderRoute: typeof SettingsOrgMembersLazyImport
      parentRoute: typeof SettingsOrgImport
    }
    '/_layout/taxa/': {
      id: '/_layout/taxa/'
      path: '/taxa'
      fullPath: '/taxa'
      preLoaderRoute: typeof LayoutTaxaIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/taxonomy/': {
      id: '/_layout/taxonomy/'
      path: '/taxonomy'
      fullPath: '/taxonomy'
      preLoaderRoute: typeof LayoutTaxonomyIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sites/': {
      id: '/_layout/sites/'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof LayoutSitesIndexLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/site/$siteSlug/collection': {
      id: '/_layout/site/$siteSlug/collection'
      path: '/collection'
      fullPath: '/site/$siteSlug/collection'
      preLoaderRoute: typeof LayoutSiteSiteSlugCollectionImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/_layout/site/$siteSlug/map': {
      id: '/_layout/site/$siteSlug/map'
      path: '/map'
      fullPath: '/site/$siteSlug/map'
      preLoaderRoute: typeof LayoutSiteSiteSlugMapImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/_layout/site/$siteSlug/trash': {
      id: '/_layout/site/$siteSlug/trash'
      path: '/trash'
      fullPath: '/site/$siteSlug/trash'
      preLoaderRoute: typeof LayoutSiteSiteSlugTrashImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/_layout/sites/$siteSlug/collection': {
      id: '/_layout/sites/$siteSlug/collection'
      path: '/collection'
      fullPath: '/sites/$siteSlug/collection'
      preLoaderRoute: typeof LayoutSitesSiteSlugCollectionImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/_layout/sites/$siteSlug/dashboard': {
      id: '/_layout/sites/$siteSlug/dashboard'
      path: '/dashboard'
      fullPath: '/sites/$siteSlug/dashboard'
      preLoaderRoute: typeof LayoutSitesSiteSlugDashboardImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/_layout/sites/$siteSlug/map': {
      id: '/_layout/sites/$siteSlug/map'
      path: '/map'
      fullPath: '/sites/$siteSlug/map'
      preLoaderRoute: typeof LayoutSitesSiteSlugMapImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/_layout/sites/$siteSlug/trash': {
      id: '/_layout/sites/$siteSlug/trash'
      path: '/trash'
      fullPath: '/sites/$siteSlug/trash'
      preLoaderRoute: typeof LayoutSitesSiteSlugTrashImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/settings/sites/$siteSlug/tags': {
      id: '/settings/sites/$siteSlug/tags'
      path: '/sites/$siteSlug/tags'
      fullPath: '/settings/sites/$siteSlug/tags'
      preLoaderRoute: typeof SettingsSitesSiteSlugTagsImport
      parentRoute: typeof SettingsImport
    }
    '/_layout/site/$siteSlug/dashboard': {
      id: '/_layout/site/$siteSlug/dashboard'
      path: '/dashboard'
      fullPath: '/site/$siteSlug/dashboard'
      preLoaderRoute: typeof LayoutSiteSiteSlugDashboardLazyImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/settings/sites/$siteSlug/general': {
      id: '/settings/sites/$siteSlug/general'
      path: '/sites/$siteSlug/general'
      fullPath: '/settings/sites/$siteSlug/general'
      preLoaderRoute: typeof SettingsSitesSiteSlugGeneralLazyImport
      parentRoute: typeof SettingsImport
    }
    '/settings/sites/$siteSlug/locations': {
      id: '/settings/sites/$siteSlug/locations'
      path: '/sites/$siteSlug/locations'
      fullPath: '/settings/sites/$siteSlug/locations'
      preLoaderRoute: typeof SettingsSitesSiteSlugLocationsLazyImport
      parentRoute: typeof SettingsImport
    }
    '/settings/sites/$siteSlug/members': {
      id: '/settings/sites/$siteSlug/members'
      path: '/sites/$siteSlug/members'
      fullPath: '/settings/sites/$siteSlug/members'
      preLoaderRoute: typeof SettingsSitesSiteSlugMembersLazyImport
      parentRoute: typeof SettingsImport
    }
    '/settings/sites/$siteSlug/public-site': {
      id: '/settings/sites/$siteSlug/public-site'
      path: '/sites/$siteSlug/public-site'
      fullPath: '/settings/sites/$siteSlug/public-site'
      preLoaderRoute: typeof SettingsSitesSiteSlugPublicSiteLazyImport
      parentRoute: typeof SettingsImport
    }
    '/_layout/site/$siteSlug/accession/$accessionNumber': {
      id: '/_layout/site/$siteSlug/accession/$accessionNumber'
      path: '/accession/$accessionNumber'
      fullPath: '/site/$siteSlug/accession/$accessionNumber'
      preLoaderRoute: typeof LayoutSiteSiteSlugAccessionAccessionNumberImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/_layout/site/$siteSlug/map/locations': {
      id: '/_layout/site/$siteSlug/map/locations'
      path: '/locations'
      fullPath: '/site/$siteSlug/map/locations'
      preLoaderRoute: typeof LayoutSiteSiteSlugMapLocationsImport
      parentRoute: typeof LayoutSiteSiteSlugMapImport
    }
    '/_layout/site/$siteSlug/map/materials': {
      id: '/_layout/site/$siteSlug/map/materials'
      path: '/materials'
      fullPath: '/site/$siteSlug/map/materials'
      preLoaderRoute: typeof LayoutSiteSiteSlugMapMaterialsImport
      parentRoute: typeof LayoutSiteSiteSlugMapImport
    }
    '/_layout/site/$siteSlug/material/$materialNumber': {
      id: '/_layout/site/$siteSlug/material/$materialNumber'
      path: '/material/$materialNumber'
      fullPath: '/site/$siteSlug/material/$materialNumber'
      preLoaderRoute: typeof LayoutSiteSiteSlugMaterialMaterialNumberImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/_layout/sites/$siteSlug/accessions/$accessionNumber': {
      id: '/_layout/sites/$siteSlug/accessions/$accessionNumber'
      path: '/accessions/$accessionNumber'
      fullPath: '/sites/$siteSlug/accessions/$accessionNumber'
      preLoaderRoute: typeof LayoutSitesSiteSlugAccessionsAccessionNumberImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/_layout/sites/$siteSlug/accessions/create': {
      id: '/_layout/sites/$siteSlug/accessions/create'
      path: '/accessions/create'
      fullPath: '/sites/$siteSlug/accessions/create'
      preLoaderRoute: typeof LayoutSitesSiteSlugAccessionsCreateImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/_layout/sites/$siteSlug/map/locations': {
      id: '/_layout/sites/$siteSlug/map/locations'
      path: '/locations'
      fullPath: '/sites/$siteSlug/map/locations'
      preLoaderRoute: typeof LayoutSitesSiteSlugMapLocationsImport
      parentRoute: typeof LayoutSitesSiteSlugMapImport
    }
    '/_layout/sites/$siteSlug/map/materials': {
      id: '/_layout/sites/$siteSlug/map/materials'
      path: '/materials'
      fullPath: '/sites/$siteSlug/map/materials'
      preLoaderRoute: typeof LayoutSitesSiteSlugMapMaterialsImport
      parentRoute: typeof LayoutSitesSiteSlugMapImport
    }
    '/_layout/sites/$siteSlug/materials/$materialNumber': {
      id: '/_layout/sites/$siteSlug/materials/$materialNumber'
      path: '/materials/$materialNumber'
      fullPath: '/sites/$siteSlug/materials/$materialNumber'
      preLoaderRoute: typeof LayoutSitesSiteSlugMaterialsMaterialNumberImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/_layout/sites/$siteSlug/materials/new': {
      id: '/_layout/sites/$siteSlug/materials/new'
      path: '/materials/new'
      fullPath: '/sites/$siteSlug/materials/new'
      preLoaderRoute: typeof LayoutSitesSiteSlugMaterialsNewImport
      parentRoute: typeof LayoutSitesSiteSlugImport
    }
    '/_layout/site/$siteSlug/accession/create': {
      id: '/_layout/site/$siteSlug/accession/create'
      path: '/accession/create'
      fullPath: '/site/$siteSlug/accession/create'
      preLoaderRoute: typeof LayoutSiteSiteSlugAccessionCreateLazyImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/_layout/site/$siteSlug/material/new': {
      id: '/_layout/site/$siteSlug/material/new'
      path: '/material/new'
      fullPath: '/site/$siteSlug/material/new'
      preLoaderRoute: typeof LayoutSiteSiteSlugMaterialNewLazyImport
      parentRoute: typeof LayoutSiteSiteSlugImport
    }
    '/_layout/site/$siteSlug/map/location/$locationName': {
      id: '/_layout/site/$siteSlug/map/location/$locationName'
      path: '/location/$locationName'
      fullPath: '/site/$siteSlug/map/location/$locationName'
      preLoaderRoute: typeof LayoutSiteSiteSlugMapLocationLocationNameImport
      parentRoute: typeof LayoutSiteSiteSlugMapImport
    }
    '/_layout/site/$siteSlug/map/material/$materialNumber': {
      id: '/_layout/site/$siteSlug/map/material/$materialNumber'
      path: '/material/$materialNumber'
      fullPath: '/site/$siteSlug/map/material/$materialNumber'
      preLoaderRoute: typeof LayoutSiteSiteSlugMapMaterialMaterialNumberImport
      parentRoute: typeof LayoutSiteSiteSlugMapImport
    }
    '/_layout/sites/$siteSlug/map/location/$locationName': {
      id: '/_layout/sites/$siteSlug/map/location/$locationName'
      path: '/location/$locationName'
      fullPath: '/sites/$siteSlug/map/location/$locationName'
      preLoaderRoute: typeof LayoutSitesSiteSlugMapLocationLocationNameImport
      parentRoute: typeof LayoutSitesSiteSlugMapImport
    }
    '/_layout/sites/$siteSlug/map/material/$materialNumber': {
      id: '/_layout/sites/$siteSlug/map/material/$materialNumber'
      path: '/material/$materialNumber'
      fullPath: '/sites/$siteSlug/map/material/$materialNumber'
      preLoaderRoute: typeof LayoutSitesSiteSlugMapMaterialMaterialNumberImport
      parentRoute: typeof LayoutSitesSiteSlugMapImport
    }
  }
}

// Create and export the route tree

interface LayoutSiteSiteSlugMapRouteChildren {
  LayoutSiteSiteSlugMapLocationsRoute: typeof LayoutSiteSiteSlugMapLocationsRoute
  LayoutSiteSiteSlugMapMaterialsRoute: typeof LayoutSiteSiteSlugMapMaterialsRoute
  LayoutSiteSiteSlugMapLocationLocationNameRoute: typeof LayoutSiteSiteSlugMapLocationLocationNameRoute
  LayoutSiteSiteSlugMapMaterialMaterialNumberRoute: typeof LayoutSiteSiteSlugMapMaterialMaterialNumberRoute
}

const LayoutSiteSiteSlugMapRouteChildren: LayoutSiteSiteSlugMapRouteChildren = {
  LayoutSiteSiteSlugMapLocationsRoute: LayoutSiteSiteSlugMapLocationsRoute,
  LayoutSiteSiteSlugMapMaterialsRoute: LayoutSiteSiteSlugMapMaterialsRoute,
  LayoutSiteSiteSlugMapLocationLocationNameRoute:
    LayoutSiteSiteSlugMapLocationLocationNameRoute,
  LayoutSiteSiteSlugMapMaterialMaterialNumberRoute:
    LayoutSiteSiteSlugMapMaterialMaterialNumberRoute,
}

const LayoutSiteSiteSlugMapRouteWithChildren =
  LayoutSiteSiteSlugMapRoute._addFileChildren(
    LayoutSiteSiteSlugMapRouteChildren,
  )

interface LayoutSiteSiteSlugRouteChildren {
  LayoutSiteSiteSlugCollectionRoute: typeof LayoutSiteSiteSlugCollectionRoute
  LayoutSiteSiteSlugMapRoute: typeof LayoutSiteSiteSlugMapRouteWithChildren
  LayoutSiteSiteSlugTrashRoute: typeof LayoutSiteSiteSlugTrashRoute
  LayoutSiteSiteSlugDashboardLazyRoute: typeof LayoutSiteSiteSlugDashboardLazyRoute
  LayoutSiteSiteSlugAccessionAccessionNumberRoute: typeof LayoutSiteSiteSlugAccessionAccessionNumberRoute
  LayoutSiteSiteSlugMaterialMaterialNumberRoute: typeof LayoutSiteSiteSlugMaterialMaterialNumberRoute
  LayoutSiteSiteSlugAccessionCreateLazyRoute: typeof LayoutSiteSiteSlugAccessionCreateLazyRoute
  LayoutSiteSiteSlugMaterialNewLazyRoute: typeof LayoutSiteSiteSlugMaterialNewLazyRoute
}

const LayoutSiteSiteSlugRouteChildren: LayoutSiteSiteSlugRouteChildren = {
  LayoutSiteSiteSlugCollectionRoute: LayoutSiteSiteSlugCollectionRoute,
  LayoutSiteSiteSlugMapRoute: LayoutSiteSiteSlugMapRouteWithChildren,
  LayoutSiteSiteSlugTrashRoute: LayoutSiteSiteSlugTrashRoute,
  LayoutSiteSiteSlugDashboardLazyRoute: LayoutSiteSiteSlugDashboardLazyRoute,
  LayoutSiteSiteSlugAccessionAccessionNumberRoute:
    LayoutSiteSiteSlugAccessionAccessionNumberRoute,
  LayoutSiteSiteSlugMaterialMaterialNumberRoute:
    LayoutSiteSiteSlugMaterialMaterialNumberRoute,
  LayoutSiteSiteSlugAccessionCreateLazyRoute:
    LayoutSiteSiteSlugAccessionCreateLazyRoute,
  LayoutSiteSiteSlugMaterialNewLazyRoute:
    LayoutSiteSiteSlugMaterialNewLazyRoute,
}

const LayoutSiteSiteSlugRouteWithChildren =
  LayoutSiteSiteSlugRoute._addFileChildren(LayoutSiteSiteSlugRouteChildren)

interface LayoutSitesSiteSlugMapRouteChildren {
  LayoutSitesSiteSlugMapLocationsRoute: typeof LayoutSitesSiteSlugMapLocationsRoute
  LayoutSitesSiteSlugMapMaterialsRoute: typeof LayoutSitesSiteSlugMapMaterialsRoute
  LayoutSitesSiteSlugMapLocationLocationNameRoute: typeof LayoutSitesSiteSlugMapLocationLocationNameRoute
  LayoutSitesSiteSlugMapMaterialMaterialNumberRoute: typeof LayoutSitesSiteSlugMapMaterialMaterialNumberRoute
}

const LayoutSitesSiteSlugMapRouteChildren: LayoutSitesSiteSlugMapRouteChildren =
  {
    LayoutSitesSiteSlugMapLocationsRoute: LayoutSitesSiteSlugMapLocationsRoute,
    LayoutSitesSiteSlugMapMaterialsRoute: LayoutSitesSiteSlugMapMaterialsRoute,
    LayoutSitesSiteSlugMapLocationLocationNameRoute:
      LayoutSitesSiteSlugMapLocationLocationNameRoute,
    LayoutSitesSiteSlugMapMaterialMaterialNumberRoute:
      LayoutSitesSiteSlugMapMaterialMaterialNumberRoute,
  }

const LayoutSitesSiteSlugMapRouteWithChildren =
  LayoutSitesSiteSlugMapRoute._addFileChildren(
    LayoutSitesSiteSlugMapRouteChildren,
  )

interface LayoutSitesSiteSlugRouteChildren {
  LayoutSitesSiteSlugCollectionRoute: typeof LayoutSitesSiteSlugCollectionRoute
  LayoutSitesSiteSlugDashboardRoute: typeof LayoutSitesSiteSlugDashboardRoute
  LayoutSitesSiteSlugMapRoute: typeof LayoutSitesSiteSlugMapRouteWithChildren
  LayoutSitesSiteSlugTrashRoute: typeof LayoutSitesSiteSlugTrashRoute
  LayoutSitesSiteSlugAccessionsAccessionNumberRoute: typeof LayoutSitesSiteSlugAccessionsAccessionNumberRoute
  LayoutSitesSiteSlugAccessionsCreateRoute: typeof LayoutSitesSiteSlugAccessionsCreateRoute
  LayoutSitesSiteSlugMaterialsMaterialNumberRoute: typeof LayoutSitesSiteSlugMaterialsMaterialNumberRoute
  LayoutSitesSiteSlugMaterialsNewRoute: typeof LayoutSitesSiteSlugMaterialsNewRoute
}

const LayoutSitesSiteSlugRouteChildren: LayoutSitesSiteSlugRouteChildren = {
  LayoutSitesSiteSlugCollectionRoute: LayoutSitesSiteSlugCollectionRoute,
  LayoutSitesSiteSlugDashboardRoute: LayoutSitesSiteSlugDashboardRoute,
  LayoutSitesSiteSlugMapRoute: LayoutSitesSiteSlugMapRouteWithChildren,
  LayoutSitesSiteSlugTrashRoute: LayoutSitesSiteSlugTrashRoute,
  LayoutSitesSiteSlugAccessionsAccessionNumberRoute:
    LayoutSitesSiteSlugAccessionsAccessionNumberRoute,
  LayoutSitesSiteSlugAccessionsCreateRoute:
    LayoutSitesSiteSlugAccessionsCreateRoute,
  LayoutSitesSiteSlugMaterialsMaterialNumberRoute:
    LayoutSitesSiteSlugMaterialsMaterialNumberRoute,
  LayoutSitesSiteSlugMaterialsNewRoute: LayoutSitesSiteSlugMaterialsNewRoute,
}

const LayoutSitesSiteSlugRouteWithChildren =
  LayoutSitesSiteSlugRoute._addFileChildren(LayoutSitesSiteSlugRouteChildren)

interface LayoutRouteChildren {
  LayoutAccessionIdRoute: typeof LayoutAccessionIdRoute
  LayoutMaterialIdRoute: typeof LayoutMaterialIdRoute
  LayoutSiteSiteSlugRoute: typeof LayoutSiteSiteSlugRouteWithChildren
  LayoutSitesSiteSlugRoute: typeof LayoutSitesSiteSlugRouteWithChildren
  LayoutTaxaTrashRoute: typeof LayoutTaxaTrashRoute
  LayoutTaxonomyTaxonIdRoute: typeof LayoutTaxonomyTaxonIdRoute
  LayoutTaxonomyNewRoute: typeof LayoutTaxonomyNewRoute
  LayoutTaxonomyTrashRoute: typeof LayoutTaxonomyTrashRoute
  LayoutTaxaNewLazyRoute: typeof LayoutTaxaNewLazyRoute
  LayoutTaxonTaxonIdLazyRoute: typeof LayoutTaxonTaxonIdLazyRoute
  LayoutTaxaIndexRoute: typeof LayoutTaxaIndexRoute
  LayoutTaxonomyIndexRoute: typeof LayoutTaxonomyIndexRoute
  LayoutSitesIndexLazyRoute: typeof LayoutSitesIndexLazyRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAccessionIdRoute: LayoutAccessionIdRoute,
  LayoutMaterialIdRoute: LayoutMaterialIdRoute,
  LayoutSiteSiteSlugRoute: LayoutSiteSiteSlugRouteWithChildren,
  LayoutSitesSiteSlugRoute: LayoutSitesSiteSlugRouteWithChildren,
  LayoutTaxaTrashRoute: LayoutTaxaTrashRoute,
  LayoutTaxonomyTaxonIdRoute: LayoutTaxonomyTaxonIdRoute,
  LayoutTaxonomyNewRoute: LayoutTaxonomyNewRoute,
  LayoutTaxonomyTrashRoute: LayoutTaxonomyTrashRoute,
  LayoutTaxaNewLazyRoute: LayoutTaxaNewLazyRoute,
  LayoutTaxonTaxonIdLazyRoute: LayoutTaxonTaxonIdLazyRoute,
  LayoutTaxaIndexRoute: LayoutTaxaIndexRoute,
  LayoutTaxonomyIndexRoute: LayoutTaxonomyIndexRoute,
  LayoutSitesIndexLazyRoute: LayoutSitesIndexLazyRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

interface SettingsOrgRouteChildren {
  SettingsOrgTagsRoute: typeof SettingsOrgTagsRoute
  SettingsOrgBillingLazyRoute: typeof SettingsOrgBillingLazyRoute
  SettingsOrgGeneralLazyRoute: typeof SettingsOrgGeneralLazyRoute
  SettingsOrgMembersLazyRoute: typeof SettingsOrgMembersLazyRoute
}

const SettingsOrgRouteChildren: SettingsOrgRouteChildren = {
  SettingsOrgTagsRoute: SettingsOrgTagsRoute,
  SettingsOrgBillingLazyRoute: SettingsOrgBillingLazyRoute,
  SettingsOrgGeneralLazyRoute: SettingsOrgGeneralLazyRoute,
  SettingsOrgMembersLazyRoute: SettingsOrgMembersLazyRoute,
}

const SettingsOrgRouteWithChildren = SettingsOrgRoute._addFileChildren(
  SettingsOrgRouteChildren,
)

interface SettingsRouteChildren {
  SettingsOrgRoute: typeof SettingsOrgRouteWithChildren
  SettingsAccountPreferencesLazyRoute: typeof SettingsAccountPreferencesLazyRoute
  SettingsAccountProfileLazyRoute: typeof SettingsAccountProfileLazyRoute
  SettingsSitesSiteSlugTagsRoute: typeof SettingsSitesSiteSlugTagsRoute
  SettingsSitesSiteSlugGeneralLazyRoute: typeof SettingsSitesSiteSlugGeneralLazyRoute
  SettingsSitesSiteSlugLocationsLazyRoute: typeof SettingsSitesSiteSlugLocationsLazyRoute
  SettingsSitesSiteSlugMembersLazyRoute: typeof SettingsSitesSiteSlugMembersLazyRoute
  SettingsSitesSiteSlugPublicSiteLazyRoute: typeof SettingsSitesSiteSlugPublicSiteLazyRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsOrgRoute: SettingsOrgRouteWithChildren,
  SettingsAccountPreferencesLazyRoute: SettingsAccountPreferencesLazyRoute,
  SettingsAccountProfileLazyRoute: SettingsAccountProfileLazyRoute,
  SettingsSitesSiteSlugTagsRoute: SettingsSitesSiteSlugTagsRoute,
  SettingsSitesSiteSlugGeneralLazyRoute: SettingsSitesSiteSlugGeneralLazyRoute,
  SettingsSitesSiteSlugLocationsLazyRoute:
    SettingsSitesSiteSlugLocationsLazyRoute,
  SettingsSitesSiteSlugMembersLazyRoute: SettingsSitesSiteSlugMembersLazyRoute,
  SettingsSitesSiteSlugPublicSiteLazyRoute:
    SettingsSitesSiteSlugPublicSiteLazyRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof LayoutRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/sites': typeof LayoutSitesIndexLazyRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/select-organisation': typeof AuthSelectOrganisationRoute
  '/settings/org': typeof SettingsOrgRouteWithChildren
  '/accession/$id': typeof LayoutAccessionIdRoute
  '/material/$id': typeof LayoutMaterialIdRoute
  '/site/$siteSlug': typeof LayoutSiteSiteSlugRouteWithChildren
  '/sites/$siteSlug': typeof LayoutSitesSiteSlugRouteWithChildren
  '/taxa/trash': typeof LayoutTaxaTrashRoute
  '/taxonomy/$taxonId': typeof LayoutTaxonomyTaxonIdRoute
  '/taxonomy/new': typeof LayoutTaxonomyNewRoute
  '/taxonomy/trash': typeof LayoutTaxonomyTrashRoute
  '/settings/org/tags': typeof SettingsOrgTagsRoute
  '/taxa/new': typeof LayoutTaxaNewLazyRoute
  '/taxon/$taxonId': typeof LayoutTaxonTaxonIdLazyRoute
  '/settings/account/preferences': typeof SettingsAccountPreferencesLazyRoute
  '/settings/account/profile': typeof SettingsAccountProfileLazyRoute
  '/settings/org/billing': typeof SettingsOrgBillingLazyRoute
  '/settings/org/general': typeof SettingsOrgGeneralLazyRoute
  '/settings/org/members': typeof SettingsOrgMembersLazyRoute
  '/taxa': typeof LayoutTaxaIndexRoute
  '/taxonomy': typeof LayoutTaxonomyIndexRoute
  '/site/$siteSlug/collection': typeof LayoutSiteSiteSlugCollectionRoute
  '/site/$siteSlug/map': typeof LayoutSiteSiteSlugMapRouteWithChildren
  '/site/$siteSlug/trash': typeof LayoutSiteSiteSlugTrashRoute
  '/sites/$siteSlug/collection': typeof LayoutSitesSiteSlugCollectionRoute
  '/sites/$siteSlug/dashboard': typeof LayoutSitesSiteSlugDashboardRoute
  '/sites/$siteSlug/map': typeof LayoutSitesSiteSlugMapRouteWithChildren
  '/sites/$siteSlug/trash': typeof LayoutSitesSiteSlugTrashRoute
  '/settings/sites/$siteSlug/tags': typeof SettingsSitesSiteSlugTagsRoute
  '/site/$siteSlug/dashboard': typeof LayoutSiteSiteSlugDashboardLazyRoute
  '/settings/sites/$siteSlug/general': typeof SettingsSitesSiteSlugGeneralLazyRoute
  '/settings/sites/$siteSlug/locations': typeof SettingsSitesSiteSlugLocationsLazyRoute
  '/settings/sites/$siteSlug/members': typeof SettingsSitesSiteSlugMembersLazyRoute
  '/settings/sites/$siteSlug/public-site': typeof SettingsSitesSiteSlugPublicSiteLazyRoute
  '/site/$siteSlug/accession/$accessionNumber': typeof LayoutSiteSiteSlugAccessionAccessionNumberRoute
  '/site/$siteSlug/map/locations': typeof LayoutSiteSiteSlugMapLocationsRoute
  '/site/$siteSlug/map/materials': typeof LayoutSiteSiteSlugMapMaterialsRoute
  '/site/$siteSlug/material/$materialNumber': typeof LayoutSiteSiteSlugMaterialMaterialNumberRoute
  '/sites/$siteSlug/accessions/$accessionNumber': typeof LayoutSitesSiteSlugAccessionsAccessionNumberRoute
  '/sites/$siteSlug/accessions/create': typeof LayoutSitesSiteSlugAccessionsCreateRoute
  '/sites/$siteSlug/map/locations': typeof LayoutSitesSiteSlugMapLocationsRoute
  '/sites/$siteSlug/map/materials': typeof LayoutSitesSiteSlugMapMaterialsRoute
  '/sites/$siteSlug/materials/$materialNumber': typeof LayoutSitesSiteSlugMaterialsMaterialNumberRoute
  '/sites/$siteSlug/materials/new': typeof LayoutSitesSiteSlugMaterialsNewRoute
  '/site/$siteSlug/accession/create': typeof LayoutSiteSiteSlugAccessionCreateLazyRoute
  '/site/$siteSlug/material/new': typeof LayoutSiteSiteSlugMaterialNewLazyRoute
  '/site/$siteSlug/map/location/$locationName': typeof LayoutSiteSiteSlugMapLocationLocationNameRoute
  '/site/$siteSlug/map/material/$materialNumber': typeof LayoutSiteSiteSlugMapMaterialMaterialNumberRoute
  '/sites/$siteSlug/map/location/$locationName': typeof LayoutSitesSiteSlugMapLocationLocationNameRoute
  '/sites/$siteSlug/map/material/$materialNumber': typeof LayoutSitesSiteSlugMapMaterialMaterialNumberRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof LayoutRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/sites': typeof LayoutSitesIndexLazyRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/select-organisation': typeof AuthSelectOrganisationRoute
  '/settings/org': typeof SettingsOrgRouteWithChildren
  '/accession/$id': typeof LayoutAccessionIdRoute
  '/material/$id': typeof LayoutMaterialIdRoute
  '/site/$siteSlug': typeof LayoutSiteSiteSlugRouteWithChildren
  '/sites/$siteSlug': typeof LayoutSitesSiteSlugRouteWithChildren
  '/taxa/trash': typeof LayoutTaxaTrashRoute
  '/taxonomy/$taxonId': typeof LayoutTaxonomyTaxonIdRoute
  '/taxonomy/new': typeof LayoutTaxonomyNewRoute
  '/taxonomy/trash': typeof LayoutTaxonomyTrashRoute
  '/settings/org/tags': typeof SettingsOrgTagsRoute
  '/taxa/new': typeof LayoutTaxaNewLazyRoute
  '/taxon/$taxonId': typeof LayoutTaxonTaxonIdLazyRoute
  '/settings/account/preferences': typeof SettingsAccountPreferencesLazyRoute
  '/settings/account/profile': typeof SettingsAccountProfileLazyRoute
  '/settings/org/billing': typeof SettingsOrgBillingLazyRoute
  '/settings/org/general': typeof SettingsOrgGeneralLazyRoute
  '/settings/org/members': typeof SettingsOrgMembersLazyRoute
  '/taxa': typeof LayoutTaxaIndexRoute
  '/taxonomy': typeof LayoutTaxonomyIndexRoute
  '/site/$siteSlug/collection': typeof LayoutSiteSiteSlugCollectionRoute
  '/site/$siteSlug/map': typeof LayoutSiteSiteSlugMapRouteWithChildren
  '/site/$siteSlug/trash': typeof LayoutSiteSiteSlugTrashRoute
  '/sites/$siteSlug/collection': typeof LayoutSitesSiteSlugCollectionRoute
  '/sites/$siteSlug/dashboard': typeof LayoutSitesSiteSlugDashboardRoute
  '/sites/$siteSlug/map': typeof LayoutSitesSiteSlugMapRouteWithChildren
  '/sites/$siteSlug/trash': typeof LayoutSitesSiteSlugTrashRoute
  '/settings/sites/$siteSlug/tags': typeof SettingsSitesSiteSlugTagsRoute
  '/site/$siteSlug/dashboard': typeof LayoutSiteSiteSlugDashboardLazyRoute
  '/settings/sites/$siteSlug/general': typeof SettingsSitesSiteSlugGeneralLazyRoute
  '/settings/sites/$siteSlug/locations': typeof SettingsSitesSiteSlugLocationsLazyRoute
  '/settings/sites/$siteSlug/members': typeof SettingsSitesSiteSlugMembersLazyRoute
  '/settings/sites/$siteSlug/public-site': typeof SettingsSitesSiteSlugPublicSiteLazyRoute
  '/site/$siteSlug/accession/$accessionNumber': typeof LayoutSiteSiteSlugAccessionAccessionNumberRoute
  '/site/$siteSlug/map/locations': typeof LayoutSiteSiteSlugMapLocationsRoute
  '/site/$siteSlug/map/materials': typeof LayoutSiteSiteSlugMapMaterialsRoute
  '/site/$siteSlug/material/$materialNumber': typeof LayoutSiteSiteSlugMaterialMaterialNumberRoute
  '/sites/$siteSlug/accessions/$accessionNumber': typeof LayoutSitesSiteSlugAccessionsAccessionNumberRoute
  '/sites/$siteSlug/accessions/create': typeof LayoutSitesSiteSlugAccessionsCreateRoute
  '/sites/$siteSlug/map/locations': typeof LayoutSitesSiteSlugMapLocationsRoute
  '/sites/$siteSlug/map/materials': typeof LayoutSitesSiteSlugMapMaterialsRoute
  '/sites/$siteSlug/materials/$materialNumber': typeof LayoutSitesSiteSlugMaterialsMaterialNumberRoute
  '/sites/$siteSlug/materials/new': typeof LayoutSitesSiteSlugMaterialsNewRoute
  '/site/$siteSlug/accession/create': typeof LayoutSiteSiteSlugAccessionCreateLazyRoute
  '/site/$siteSlug/material/new': typeof LayoutSiteSiteSlugMaterialNewLazyRoute
  '/site/$siteSlug/map/location/$locationName': typeof LayoutSiteSiteSlugMapLocationLocationNameRoute
  '/site/$siteSlug/map/material/$materialNumber': typeof LayoutSiteSiteSlugMapMaterialMaterialNumberRoute
  '/sites/$siteSlug/map/location/$locationName': typeof LayoutSitesSiteSlugMapLocationLocationNameRoute
  '/sites/$siteSlug/map/material/$materialNumber': typeof LayoutSitesSiteSlugMapMaterialMaterialNumberRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/sites': typeof SitesRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/select-organisation': typeof AuthSelectOrganisationRoute
  '/settings/org': typeof SettingsOrgRouteWithChildren
  '/_layout/accession/$id': typeof LayoutAccessionIdRoute
  '/_layout/material/$id': typeof LayoutMaterialIdRoute
  '/_layout/site/$siteSlug': typeof LayoutSiteSiteSlugRouteWithChildren
  '/_layout/sites/$siteSlug': typeof LayoutSitesSiteSlugRouteWithChildren
  '/_layout/taxa/trash': typeof LayoutTaxaTrashRoute
  '/_layout/taxonomy/$taxonId': typeof LayoutTaxonomyTaxonIdRoute
  '/_layout/taxonomy/new': typeof LayoutTaxonomyNewRoute
  '/_layout/taxonomy/trash': typeof LayoutTaxonomyTrashRoute
  '/settings/org/tags': typeof SettingsOrgTagsRoute
  '/_layout/taxa/new': typeof LayoutTaxaNewLazyRoute
  '/_layout/taxon/$taxonId': typeof LayoutTaxonTaxonIdLazyRoute
  '/settings/account/preferences': typeof SettingsAccountPreferencesLazyRoute
  '/settings/account/profile': typeof SettingsAccountProfileLazyRoute
  '/settings/org/billing': typeof SettingsOrgBillingLazyRoute
  '/settings/org/general': typeof SettingsOrgGeneralLazyRoute
  '/settings/org/members': typeof SettingsOrgMembersLazyRoute
  '/_layout/taxa/': typeof LayoutTaxaIndexRoute
  '/_layout/taxonomy/': typeof LayoutTaxonomyIndexRoute
  '/_layout/sites/': typeof LayoutSitesIndexLazyRoute
  '/_layout/site/$siteSlug/collection': typeof LayoutSiteSiteSlugCollectionRoute
  '/_layout/site/$siteSlug/map': typeof LayoutSiteSiteSlugMapRouteWithChildren
  '/_layout/site/$siteSlug/trash': typeof LayoutSiteSiteSlugTrashRoute
  '/_layout/sites/$siteSlug/collection': typeof LayoutSitesSiteSlugCollectionRoute
  '/_layout/sites/$siteSlug/dashboard': typeof LayoutSitesSiteSlugDashboardRoute
  '/_layout/sites/$siteSlug/map': typeof LayoutSitesSiteSlugMapRouteWithChildren
  '/_layout/sites/$siteSlug/trash': typeof LayoutSitesSiteSlugTrashRoute
  '/settings/sites/$siteSlug/tags': typeof SettingsSitesSiteSlugTagsRoute
  '/_layout/site/$siteSlug/dashboard': typeof LayoutSiteSiteSlugDashboardLazyRoute
  '/settings/sites/$siteSlug/general': typeof SettingsSitesSiteSlugGeneralLazyRoute
  '/settings/sites/$siteSlug/locations': typeof SettingsSitesSiteSlugLocationsLazyRoute
  '/settings/sites/$siteSlug/members': typeof SettingsSitesSiteSlugMembersLazyRoute
  '/settings/sites/$siteSlug/public-site': typeof SettingsSitesSiteSlugPublicSiteLazyRoute
  '/_layout/site/$siteSlug/accession/$accessionNumber': typeof LayoutSiteSiteSlugAccessionAccessionNumberRoute
  '/_layout/site/$siteSlug/map/locations': typeof LayoutSiteSiteSlugMapLocationsRoute
  '/_layout/site/$siteSlug/map/materials': typeof LayoutSiteSiteSlugMapMaterialsRoute
  '/_layout/site/$siteSlug/material/$materialNumber': typeof LayoutSiteSiteSlugMaterialMaterialNumberRoute
  '/_layout/sites/$siteSlug/accessions/$accessionNumber': typeof LayoutSitesSiteSlugAccessionsAccessionNumberRoute
  '/_layout/sites/$siteSlug/accessions/create': typeof LayoutSitesSiteSlugAccessionsCreateRoute
  '/_layout/sites/$siteSlug/map/locations': typeof LayoutSitesSiteSlugMapLocationsRoute
  '/_layout/sites/$siteSlug/map/materials': typeof LayoutSitesSiteSlugMapMaterialsRoute
  '/_layout/sites/$siteSlug/materials/$materialNumber': typeof LayoutSitesSiteSlugMaterialsMaterialNumberRoute
  '/_layout/sites/$siteSlug/materials/new': typeof LayoutSitesSiteSlugMaterialsNewRoute
  '/_layout/site/$siteSlug/accession/create': typeof LayoutSiteSiteSlugAccessionCreateLazyRoute
  '/_layout/site/$siteSlug/material/new': typeof LayoutSiteSiteSlugMaterialNewLazyRoute
  '/_layout/site/$siteSlug/map/location/$locationName': typeof LayoutSiteSiteSlugMapLocationLocationNameRoute
  '/_layout/site/$siteSlug/map/material/$materialNumber': typeof LayoutSiteSiteSlugMapMaterialMaterialNumberRoute
  '/_layout/sites/$siteSlug/map/location/$locationName': typeof LayoutSitesSiteSlugMapLocationLocationNameRoute
  '/_layout/sites/$siteSlug/map/material/$materialNumber': typeof LayoutSitesSiteSlugMapMaterialMaterialNumberRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/settings'
    | '/sites'
    | '/auth/error'
    | '/auth/login'
    | '/auth/select-organisation'
    | '/settings/org'
    | '/accession/$id'
    | '/material/$id'
    | '/site/$siteSlug'
    | '/sites/$siteSlug'
    | '/taxa/trash'
    | '/taxonomy/$taxonId'
    | '/taxonomy/new'
    | '/taxonomy/trash'
    | '/settings/org/tags'
    | '/taxa/new'
    | '/taxon/$taxonId'
    | '/settings/account/preferences'
    | '/settings/account/profile'
    | '/settings/org/billing'
    | '/settings/org/general'
    | '/settings/org/members'
    | '/taxa'
    | '/taxonomy'
    | '/site/$siteSlug/collection'
    | '/site/$siteSlug/map'
    | '/site/$siteSlug/trash'
    | '/sites/$siteSlug/collection'
    | '/sites/$siteSlug/dashboard'
    | '/sites/$siteSlug/map'
    | '/sites/$siteSlug/trash'
    | '/settings/sites/$siteSlug/tags'
    | '/site/$siteSlug/dashboard'
    | '/settings/sites/$siteSlug/general'
    | '/settings/sites/$siteSlug/locations'
    | '/settings/sites/$siteSlug/members'
    | '/settings/sites/$siteSlug/public-site'
    | '/site/$siteSlug/accession/$accessionNumber'
    | '/site/$siteSlug/map/locations'
    | '/site/$siteSlug/map/materials'
    | '/site/$siteSlug/material/$materialNumber'
    | '/sites/$siteSlug/accessions/$accessionNumber'
    | '/sites/$siteSlug/accessions/create'
    | '/sites/$siteSlug/map/locations'
    | '/sites/$siteSlug/map/materials'
    | '/sites/$siteSlug/materials/$materialNumber'
    | '/sites/$siteSlug/materials/new'
    | '/site/$siteSlug/accession/create'
    | '/site/$siteSlug/material/new'
    | '/site/$siteSlug/map/location/$locationName'
    | '/site/$siteSlug/map/material/$materialNumber'
    | '/sites/$siteSlug/map/location/$locationName'
    | '/sites/$siteSlug/map/material/$materialNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/settings'
    | '/sites'
    | '/auth/error'
    | '/auth/login'
    | '/auth/select-organisation'
    | '/settings/org'
    | '/accession/$id'
    | '/material/$id'
    | '/site/$siteSlug'
    | '/sites/$siteSlug'
    | '/taxa/trash'
    | '/taxonomy/$taxonId'
    | '/taxonomy/new'
    | '/taxonomy/trash'
    | '/settings/org/tags'
    | '/taxa/new'
    | '/taxon/$taxonId'
    | '/settings/account/preferences'
    | '/settings/account/profile'
    | '/settings/org/billing'
    | '/settings/org/general'
    | '/settings/org/members'
    | '/taxa'
    | '/taxonomy'
    | '/site/$siteSlug/collection'
    | '/site/$siteSlug/map'
    | '/site/$siteSlug/trash'
    | '/sites/$siteSlug/collection'
    | '/sites/$siteSlug/dashboard'
    | '/sites/$siteSlug/map'
    | '/sites/$siteSlug/trash'
    | '/settings/sites/$siteSlug/tags'
    | '/site/$siteSlug/dashboard'
    | '/settings/sites/$siteSlug/general'
    | '/settings/sites/$siteSlug/locations'
    | '/settings/sites/$siteSlug/members'
    | '/settings/sites/$siteSlug/public-site'
    | '/site/$siteSlug/accession/$accessionNumber'
    | '/site/$siteSlug/map/locations'
    | '/site/$siteSlug/map/materials'
    | '/site/$siteSlug/material/$materialNumber'
    | '/sites/$siteSlug/accessions/$accessionNumber'
    | '/sites/$siteSlug/accessions/create'
    | '/sites/$siteSlug/map/locations'
    | '/sites/$siteSlug/map/materials'
    | '/sites/$siteSlug/materials/$materialNumber'
    | '/sites/$siteSlug/materials/new'
    | '/site/$siteSlug/accession/create'
    | '/site/$siteSlug/material/new'
    | '/site/$siteSlug/map/location/$locationName'
    | '/site/$siteSlug/map/material/$materialNumber'
    | '/sites/$siteSlug/map/location/$locationName'
    | '/sites/$siteSlug/map/material/$materialNumber'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/settings'
    | '/sites'
    | '/auth/error'
    | '/auth/login'
    | '/auth/select-organisation'
    | '/settings/org'
    | '/_layout/accession/$id'
    | '/_layout/material/$id'
    | '/_layout/site/$siteSlug'
    | '/_layout/sites/$siteSlug'
    | '/_layout/taxa/trash'
    | '/_layout/taxonomy/$taxonId'
    | '/_layout/taxonomy/new'
    | '/_layout/taxonomy/trash'
    | '/settings/org/tags'
    | '/_layout/taxa/new'
    | '/_layout/taxon/$taxonId'
    | '/settings/account/preferences'
    | '/settings/account/profile'
    | '/settings/org/billing'
    | '/settings/org/general'
    | '/settings/org/members'
    | '/_layout/taxa/'
    | '/_layout/taxonomy/'
    | '/_layout/sites/'
    | '/_layout/site/$siteSlug/collection'
    | '/_layout/site/$siteSlug/map'
    | '/_layout/site/$siteSlug/trash'
    | '/_layout/sites/$siteSlug/collection'
    | '/_layout/sites/$siteSlug/dashboard'
    | '/_layout/sites/$siteSlug/map'
    | '/_layout/sites/$siteSlug/trash'
    | '/settings/sites/$siteSlug/tags'
    | '/_layout/site/$siteSlug/dashboard'
    | '/settings/sites/$siteSlug/general'
    | '/settings/sites/$siteSlug/locations'
    | '/settings/sites/$siteSlug/members'
    | '/settings/sites/$siteSlug/public-site'
    | '/_layout/site/$siteSlug/accession/$accessionNumber'
    | '/_layout/site/$siteSlug/map/locations'
    | '/_layout/site/$siteSlug/map/materials'
    | '/_layout/site/$siteSlug/material/$materialNumber'
    | '/_layout/sites/$siteSlug/accessions/$accessionNumber'
    | '/_layout/sites/$siteSlug/accessions/create'
    | '/_layout/sites/$siteSlug/map/locations'
    | '/_layout/sites/$siteSlug/map/materials'
    | '/_layout/sites/$siteSlug/materials/$materialNumber'
    | '/_layout/sites/$siteSlug/materials/new'
    | '/_layout/site/$siteSlug/accession/create'
    | '/_layout/site/$siteSlug/material/new'
    | '/_layout/site/$siteSlug/map/location/$locationName'
    | '/_layout/site/$siteSlug/map/material/$materialNumber'
    | '/_layout/sites/$siteSlug/map/location/$locationName'
    | '/_layout/sites/$siteSlug/map/material/$materialNumber'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  SitesRoute: typeof SitesRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSelectOrganisationRoute: typeof AuthSelectOrganisationRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  SitesRoute: SitesRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSelectOrganisationRoute: AuthSelectOrganisationRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_layout",
        "/settings",
        "/sites",
        "/auth/error",
        "/auth/login",
        "/auth/select-organisation"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/accession/$id",
        "/_layout/material/$id",
        "/_layout/site/$siteSlug",
        "/_layout/sites/$siteSlug",
        "/_layout/taxa/trash",
        "/_layout/taxonomy/$taxonId",
        "/_layout/taxonomy/new",
        "/_layout/taxonomy/trash",
        "/_layout/taxa/new",
        "/_layout/taxon/$taxonId",
        "/_layout/taxa/",
        "/_layout/taxonomy/",
        "/_layout/sites/"
      ]
    },
    "/settings": {
      "filePath": "settings.tsx",
      "children": [
        "/settings/org",
        "/settings/account/preferences",
        "/settings/account/profile",
        "/settings/sites/$siteSlug/tags",
        "/settings/sites/$siteSlug/general",
        "/settings/sites/$siteSlug/locations",
        "/settings/sites/$siteSlug/members",
        "/settings/sites/$siteSlug/public-site"
      ]
    },
    "/sites": {
      "filePath": "sites.tsx"
    },
    "/auth/error": {
      "filePath": "auth/error.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/select-organisation": {
      "filePath": "auth/select-organisation.tsx"
    },
    "/settings/org": {
      "filePath": "settings/org.tsx",
      "parent": "/settings",
      "children": [
        "/settings/org/tags",
        "/settings/org/billing",
        "/settings/org/general",
        "/settings/org/members"
      ]
    },
    "/_layout/accession/$id": {
      "filePath": "_layout/accession/$id.tsx",
      "parent": "/_layout"
    },
    "/_layout/material/$id": {
      "filePath": "_layout/material/$id.tsx",
      "parent": "/_layout"
    },
    "/_layout/site/$siteSlug": {
      "filePath": "_layout/site/$siteSlug.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/site/$siteSlug/collection",
        "/_layout/site/$siteSlug/map",
        "/_layout/site/$siteSlug/trash",
        "/_layout/site/$siteSlug/dashboard",
        "/_layout/site/$siteSlug/accession/$accessionNumber",
        "/_layout/site/$siteSlug/material/$materialNumber",
        "/_layout/site/$siteSlug/accession/create",
        "/_layout/site/$siteSlug/material/new"
      ]
    },
    "/_layout/sites/$siteSlug": {
      "filePath": "_layout/sites/$siteSlug.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/sites/$siteSlug/collection",
        "/_layout/sites/$siteSlug/dashboard",
        "/_layout/sites/$siteSlug/map",
        "/_layout/sites/$siteSlug/trash",
        "/_layout/sites/$siteSlug/accessions/$accessionNumber",
        "/_layout/sites/$siteSlug/accessions/create",
        "/_layout/sites/$siteSlug/materials/$materialNumber",
        "/_layout/sites/$siteSlug/materials/new"
      ]
    },
    "/_layout/taxa/trash": {
      "filePath": "_layout/taxa/trash.tsx",
      "parent": "/_layout"
    },
    "/_layout/taxonomy/$taxonId": {
      "filePath": "_layout/taxonomy/$taxonId.tsx",
      "parent": "/_layout"
    },
    "/_layout/taxonomy/new": {
      "filePath": "_layout/taxonomy/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/taxonomy/trash": {
      "filePath": "_layout/taxonomy/trash.tsx",
      "parent": "/_layout"
    },
    "/settings/org/tags": {
      "filePath": "settings/org/tags.tsx",
      "parent": "/settings/org"
    },
    "/_layout/taxa/new": {
      "filePath": "_layout/taxa/new.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/taxon/$taxonId": {
      "filePath": "_layout/taxon/$taxonId.lazy.tsx",
      "parent": "/_layout"
    },
    "/settings/account/preferences": {
      "filePath": "settings/account/preferences.lazy.tsx",
      "parent": "/settings"
    },
    "/settings/account/profile": {
      "filePath": "settings/account/profile.lazy.tsx",
      "parent": "/settings"
    },
    "/settings/org/billing": {
      "filePath": "settings/org/billing.lazy.tsx",
      "parent": "/settings/org"
    },
    "/settings/org/general": {
      "filePath": "settings/org/general.lazy.tsx",
      "parent": "/settings/org"
    },
    "/settings/org/members": {
      "filePath": "settings/org/members.lazy.tsx",
      "parent": "/settings/org"
    },
    "/_layout/taxa/": {
      "filePath": "_layout/taxa/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/taxonomy/": {
      "filePath": "_layout/taxonomy/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sites/": {
      "filePath": "_layout/sites/index.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/site/$siteSlug/collection": {
      "filePath": "_layout/site/$siteSlug/collection.tsx",
      "parent": "/_layout/site/$siteSlug"
    },
    "/_layout/site/$siteSlug/map": {
      "filePath": "_layout/site/$siteSlug/map.tsx",
      "parent": "/_layout/site/$siteSlug",
      "children": [
        "/_layout/site/$siteSlug/map/locations",
        "/_layout/site/$siteSlug/map/materials",
        "/_layout/site/$siteSlug/map/location/$locationName",
        "/_layout/site/$siteSlug/map/material/$materialNumber"
      ]
    },
    "/_layout/site/$siteSlug/trash": {
      "filePath": "_layout/site/$siteSlug/trash.tsx",
      "parent": "/_layout/site/$siteSlug"
    },
    "/_layout/sites/$siteSlug/collection": {
      "filePath": "_layout/sites/$siteSlug/collection.tsx",
      "parent": "/_layout/sites/$siteSlug"
    },
    "/_layout/sites/$siteSlug/dashboard": {
      "filePath": "_layout/sites/$siteSlug/dashboard.tsx",
      "parent": "/_layout/sites/$siteSlug"
    },
    "/_layout/sites/$siteSlug/map": {
      "filePath": "_layout/sites/$siteSlug/map.tsx",
      "parent": "/_layout/sites/$siteSlug",
      "children": [
        "/_layout/sites/$siteSlug/map/locations",
        "/_layout/sites/$siteSlug/map/materials",
        "/_layout/sites/$siteSlug/map/location/$locationName",
        "/_layout/sites/$siteSlug/map/material/$materialNumber"
      ]
    },
    "/_layout/sites/$siteSlug/trash": {
      "filePath": "_layout/sites/$siteSlug/trash.tsx",
      "parent": "/_layout/sites/$siteSlug"
    },
    "/settings/sites/$siteSlug/tags": {
      "filePath": "settings/sites/$siteSlug/tags.tsx",
      "parent": "/settings"
    },
    "/_layout/site/$siteSlug/dashboard": {
      "filePath": "_layout/site/$siteSlug/dashboard.lazy.tsx",
      "parent": "/_layout/site/$siteSlug"
    },
    "/settings/sites/$siteSlug/general": {
      "filePath": "settings/sites/$siteSlug/general.lazy.tsx",
      "parent": "/settings"
    },
    "/settings/sites/$siteSlug/locations": {
      "filePath": "settings/sites/$siteSlug/locations.lazy.tsx",
      "parent": "/settings"
    },
    "/settings/sites/$siteSlug/members": {
      "filePath": "settings/sites/$siteSlug/members.lazy.tsx",
      "parent": "/settings"
    },
    "/settings/sites/$siteSlug/public-site": {
      "filePath": "settings/sites/$siteSlug/public-site.lazy.tsx",
      "parent": "/settings"
    },
    "/_layout/site/$siteSlug/accession/$accessionNumber": {
      "filePath": "_layout/site/$siteSlug/accession/$accessionNumber.tsx",
      "parent": "/_layout/site/$siteSlug"
    },
    "/_layout/site/$siteSlug/map/locations": {
      "filePath": "_layout/site/$siteSlug/map/locations.tsx",
      "parent": "/_layout/site/$siteSlug/map"
    },
    "/_layout/site/$siteSlug/map/materials": {
      "filePath": "_layout/site/$siteSlug/map/materials.tsx",
      "parent": "/_layout/site/$siteSlug/map"
    },
    "/_layout/site/$siteSlug/material/$materialNumber": {
      "filePath": "_layout/site/$siteSlug/material/$materialNumber.tsx",
      "parent": "/_layout/site/$siteSlug"
    },
    "/_layout/sites/$siteSlug/accessions/$accessionNumber": {
      "filePath": "_layout/sites/$siteSlug/accessions/$accessionNumber.tsx",
      "parent": "/_layout/sites/$siteSlug"
    },
    "/_layout/sites/$siteSlug/accessions/create": {
      "filePath": "_layout/sites/$siteSlug/accessions/create.tsx",
      "parent": "/_layout/sites/$siteSlug"
    },
    "/_layout/sites/$siteSlug/map/locations": {
      "filePath": "_layout/sites/$siteSlug/map/locations.tsx",
      "parent": "/_layout/sites/$siteSlug/map"
    },
    "/_layout/sites/$siteSlug/map/materials": {
      "filePath": "_layout/sites/$siteSlug/map/materials.tsx",
      "parent": "/_layout/sites/$siteSlug/map"
    },
    "/_layout/sites/$siteSlug/materials/$materialNumber": {
      "filePath": "_layout/sites/$siteSlug/materials/$materialNumber.tsx",
      "parent": "/_layout/sites/$siteSlug"
    },
    "/_layout/sites/$siteSlug/materials/new": {
      "filePath": "_layout/sites/$siteSlug/materials/new.tsx",
      "parent": "/_layout/sites/$siteSlug"
    },
    "/_layout/site/$siteSlug/accession/create": {
      "filePath": "_layout/site/$siteSlug/accession/create.lazy.tsx",
      "parent": "/_layout/site/$siteSlug"
    },
    "/_layout/site/$siteSlug/material/new": {
      "filePath": "_layout/site/$siteSlug/material/new.lazy.tsx",
      "parent": "/_layout/site/$siteSlug"
    },
    "/_layout/site/$siteSlug/map/location/$locationName": {
      "filePath": "_layout/site/$siteSlug/map/location/$locationName.tsx",
      "parent": "/_layout/site/$siteSlug/map"
    },
    "/_layout/site/$siteSlug/map/material/$materialNumber": {
      "filePath": "_layout/site/$siteSlug/map/material/$materialNumber.tsx",
      "parent": "/_layout/site/$siteSlug/map"
    },
    "/_layout/sites/$siteSlug/map/location/$locationName": {
      "filePath": "_layout/sites/$siteSlug/map/location/$locationName.tsx",
      "parent": "/_layout/sites/$siteSlug/map"
    },
    "/_layout/sites/$siteSlug/map/material/$materialNumber": {
      "filePath": "_layout/sites/$siteSlug/map/material/$materialNumber.tsx",
      "parent": "/_layout/sites/$siteSlug/map"
    }
  }
}
ROUTE_MANIFEST_END */
